import { DictionaryLink, HTMLBlock } from "../../../rest/models";
import { RenderSentence } from "./RenderSentence";
import { useAppSelector } from "../../../store/hooks";
import { EWRBlockEditor } from "./editwhilereading/EWRBlockEditor";
import { useState } from "react";
import { Button } from "../../RequestRespectingInputs";

/**
 * Used for books where !b.is_html.
 * 
 * Renders an HTMLBlock as a plain-text paragraph, without all the bells and whistles that an actual HTML block needs.
 */
export function RenderPlainTextParagraph(props: Props)
{
    const b = props.block;
    const dl = props.dict_links;

    const {sentencesForBlock, sentencesOnPage} = useAppSelector(function(state)
    {
        const sbr = state.bookReader;
        return (
        {
            sentencesForBlock: sbr.sentencesByBlock[b.block_id],
            sentencesOnPage: sbr.pagination.sentences,
        });
    });

    const sentences = sentencesForBlock?.filter(s => s.sentence_id >= sentencesOnPage.first && s.sentence_id < sentencesOnPage.last) || [];
    
    const [collapsed, setCollapsed] = useState(false);

    const blockEditor = !props.isPreview
    ? <EWRBlockEditor block={b}/>
    : <></>;

    return (
    <fieldset className='ernots_RenderBlock'>
        <legend>
            Paragraph #{b.block_id + 1}
            <Button onClick={e => setCollapsed(!collapsed)}>{collapsed ? '►' : '▼'}</Button>
        </legend>
        {collapsed
            ? null
            : <>
                {sentences.map(s => <RenderSentence key={s.key} sentence={s} dictLinks={dl} isPreview={props.isPreview}/>)}
                {blockEditor}
            </>}
    </fieldset>);
}

interface Props
{
    block: HTMLBlock;
    dict_links: {[language_id: string]: DictionaryLink[]};
    isPreview: boolean;
}